import { ActionStatusEnum, ActionTypeEnum } from "./action.enum";

export enum GroupLabelStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export interface GroupLabel {
  _id: string;
  name: string;
  status: GroupLabelStatusEnum;
  description: string;
}

export type SearchGroupLabelPayload = {
  sortField: string;
  sortOrder: number;
  pageNumber: number;
  pageSize: number;
  search: string;
  status?: string[];
};

export interface SearchGroupLabelResponse {
  groupLabels: GroupLabel[];
  totalCount: number;
}

export interface GroupLabelCreateRequestPayload
  extends Omit<GroupLabel, "_id"> {
  createdBy: string;
}

export interface GroupLabelUpdateRequestPayload extends GroupLabel {
  updatedBy: string;
}
